<template>
    <div>
        <CRow class="mb-3 ml-2">
            <h3>결제 상세 정보</h3>
        </CRow>
        <form style="width: 100%">
            <CRow>
                <CCol md="12">
                <div class="card">
                    <!--<div class="card-header">결제 상세정보</div>-->
                    <div class="card-body">
                        <div class="bd-example" v-if="kspayItem.trType == 'S'">
                            <dl class="row">
                                <dt class="col-sm-2"><label class="col-form-label col-sm-10"> 결제번호 </label></dt>
                                <dd class="col-sm-3">
                                    <div role="group" class="form-group  form-row">
                                        <div class="col-sm-12">
                                            <div  type="text" required="required" class="form-control">{{kspayItem.transId}}</div>
                                        </div>
                                    </div>
                                </dd>
                                <dt class="col-sm-2"><label class="col-form-label col-sm-10">결제일</label></dt>
                                <dd class="col-sm-3">
                                    <div role="group" class="form-group  form-row">
                                        <div class="col-sm-12">
                                            <div type="text" required="required" class="form-control">{{$moment(kspayItem.insertTime).format("YYYY-MM-DD HH:mm:ss" )}}</div>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <dl class="row">
                                <dt class="col-sm-2"><label class="col-form-label col-sm-10"> 승인번호 </label></dt>
                                <dd class="col-sm-3">
                                    <div role="group" class="form-group  form-row">
                                        <div class="col-sm-12">
                                            <div id="uid-dq9zl88hwf8" type="text" required="required" class="form-control">{{kspayItem.authNo}}</div>
                                        </div>
                                    </div>
                                </dd>
                                <dt class="col-sm-2"><label class="col-form-label col-sm-10"> 승인시간 </label></dt>
                                <dd class="col-sm-3">
                                    <div role="group" class="form-group  form-row">
                                        <div class="col-sm-12">
                                            <div  type="text" required="required" class="form-control">{{$moment(kspayItem.approveDate).format("YYYY-MM-DD" )+" "+ approveDateHHmmss}}</div>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <dl class="row">
                                <dt class="col-sm-2"><label class="col-form-label col-sm-10"> 결제금액 </label></dt>
                                <dd class="col-sm-3">
                                    <div role="group" class="form-group  form-row">
                                        <div class="col-sm-12">
                                            <div  type="text" required="required" class="form-control" >{{kspayItem.amount | comma}} 원</div>
                                        </div>
                                    </div>
                                </dd>
                                <dt class="col-sm-2"><label class="col-form-label col-sm-10"> 결제수단 </label></dt>
                                <dd class="col-sm-3">
                                    <div role="group" class="form-group  form-row">
                                        <div class="col-sm-12">
                                            <div  type="text" required="required" class="form-control">{{payMethod }}</div>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <dl class="row">
                                <dt class="col-sm-2"><label class="col-form-label col-sm-10"> 카드사 </label></dt>
                                <dd class="col-sm-3">
                                    <div role="group" class="form-group  form-row">
                                        <div class="col-sm-12">
                                            <div  type="text" required="required" class="form-control">{{cardName}}</div>
                                        </div>
                                    </div>
                                </dd>
                                <dt class="col-sm-2"><label class="col-form-label col-sm-10"> 결제자 </label></dt>
                                <dd class="col-sm-3">
                                    <div role="group" class="form-group  form-row">
                                        <div class="col-sm-12">
                                            <div  type="text" required="required" class="form-control" >{{kspayItem.buyerTel}}</div>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <div v-if="kspayItem.trType != 'S'">
                        <dl class="row">
                            <dt class="col-sm-2"><label class="col-form-label col-sm-10"> 결제번호 </label></dt>
                            <dd class="col-sm-3">
                                <div role="group" class="form-group  form-row">
                                    <div class="col-sm-12">
                                        <div v-if="kspayItem.transId != null" type="text" required="required" class="form-control">{{kspayItem.transId}}</div>
                                        <div v-if="kspayItem.transId == null" type="text" required="required" class="form-control">결제에 실패하였습니다</div>
                                    </div>
                                </div>
                            </dd>
                            <dt class="col-sm-2"><label class="col-form-label col-sm-10">등록일</label></dt>
                            <dd class="col-sm-3">
                                <div role="group" class="form-group  form-row">
                                    <div class="col-sm-12">
                                        <div  type="text" required="required" class="form-control">{{$moment(kspayItem.insertTime).format("YYYY-MM-DD HH:mm:ss" )}}</div>
                                    </div>
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-2"><label class="col-form-label col-sm-10"> 결제금액 </label></dt>
                            <dd class="col-sm-3">
                                <div role="group" class="form-group  form-row">
                                    <div class="col-sm-12">
                                        <div  type="text" required="required" class="form-control" >{{kspayItem.amount | comma}} 원</div>
                                    </div>
                                </div>
                            </dd>
                            <dt class="col-sm-2"><label class="col-form-label col-sm-10"> 결제수단 </label></dt>
                            <dd class="col-sm-3">
                                <div role="group" class="form-group  form-row">
                                    <div class="col-sm-12">
                                        <div  type="text" required="required" class="form-control">{{payMethod }}</div>
                                    </div>
                                </div>
                            </dd>
                        </dl>

                    </div>
                </div>
                </CCol>
            </CRow>
            <div class="col-sm-0.5">
                <CButton label=""
                         type="button"
                         style="text-align: right"
                         class="btn btn-info " @click="backHistory">뒤로가기
                </CButton>
                <CButton label=""
                         type="button"
                         style="text-align: right; margin-left: 10px;"
                         class="btn btn-info " @click="cardChit">카드전표 인쇄
                </CButton>
                <CButton label=""
                         type="button"
                         style="text-align: right; float: right;"
                         class="btn btn-info " @click="cancelPayment">결제취소
                </CButton>
            </div>
        </form>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .col-title{
        width: 20%;
    }
    .table-span-margin{
        margin-left: 10%;
    }
</style>
<script>
    import Vue from 'vue'
    import axios from "axios";
    import VueMoment from 'vue-moment'

    Vue.use(VueMoment)

    export default {
        name: 'paymanageupdate',
        components: {
        },
        data() {
            return{
                custItem: {},
                custPayItem: {},
                kspayItem: {},
                payItems: {},
                item: null,
                payId:'',
                approveDateHHmmss:"",
                payMethod:"",
                cardName:""
            }
        },
        filters:{
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
        mounted() {
            const payId = this.$route.params.payId;
            axios.get('silver/pay/getPayDetailInfo/'+payId)
                .then(res => {
                    this.kspayItem = res.data.custPay;
                    this.approveDateHHmmss = res.data.approveDateHHmmss;
                    this.cardName = res.data.cardName;
                    if (this.kspayItem.payMethod === 'C'){
                        this.payMethod = "카드";
                    }

                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        methods: {
            backHistory() {
                this.$router.go(-1)
            },
            cancelPayment() {
                const payId = this.$route.params.payId;
                axios.get('silver/pay/cancelPayment/'+payId)
                    .then(res => {
                        if(res.data.response.ErrorStatus == "O" && res.data.response.Message2 == "기취소거래") {
                            alert("이미 취소된 결제입니다.");
                            this.$router.go(-1)
                        }else if(res.data.response.ErrorStatus == "O" ) {
                            alert("승인취소되었습니다.")
                            this.$router.go(-1)
                        }else {
                            alert("승인에 실패했습니다. 실패이유 : " + res.data.response.Message1);
                            this.$router.go(-1)
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            cardChit() {
                const payId = this.$route.params.payId;
                this.windowRef = window.open("#/card/cardchit/"+payId, "admininsert", "width=800,height=800,left=200,top=200");
                this.windowRef.addEventListener('beforeunload', this.closePortal);
                // magic!
            },
            closePortal() {
                if(this.windowRef) {
                    this.windowRef.close();
                    this.windowRef = null;
                    this.$emit('close');
                }
            }
        }
    }
</script>
